module.exports = __webpack_public_path__ + "img/hatudo.339321b4.png";